module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Semibold.556687b.woff";